// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37EVu","colBig":"styles_colBig__U6qqC","colSmall":"styles_colSmall__11CJr"};